import API from '..';
const ENTITY = 'rates';

export const getItems = () => API.get(`/api/v1/${ENTITY}/`);
